module.exports = __webpack_public_path__ + "img/two_lines-svg.5618476b.svg";